const BASE_URL = process.env.REACT_APP_API_URL || 'https://gec.energymarketplace.in/gec-backend/api/v1';

const API_ENDPOINTS = {
    // Auth endpoints
    AUTH: {
        LOGIN: '/users/login',
        LOGOUT: '/api/auth/logout',
        REFRESH: '/auth/refresh-tokens',
        PROFILE: '/auth/profile',
        ME: '/auth/me',
        REGISTER: "/users/register",
        VERIFY_OTP: "/auth/validate-otp",
        FORGOT_PASSWORD: {
            VERIFY_USER: "/auth/forgot-password",
            RESEND_OTP: "",
            VERIFY_OTP: (token: string) => `/auth/verify-email?token=${token}`
        },
        RESET_PASSWORD: (token: string) => `/auth/reset-password`
    },
    UPLOAD_DOCUMENT: "/document/upload",
    CONSUMER_DETAILS_BY_CONSUMER_NO: "/company/consumer/details",
       DROPDOWN: {
        TIMESLOTS: "/dropdowns/timeslots"
    },
    DASHBOARD: {
        GENERATOR_SUMMARY: "/dashboard/generator/summary",
        GENERATOR_RECENT_LIST: "dashboard/generator/recent",
        GENERATOR_GRAPH_READING: "dashboard/generator/readings",
        GENERATION_ENERGY_HEATMAP: "/dashboard/generator/heatmap",
          CONSUMER_AUDIT_SUMMARY: "/dashboard/generator/audit/summary",
        CONSUMER_TOLLTIL_LIST: "/dashboard/generator/audit/list"


    },
    ENERGY_MONITORING_DASHBOARD: {
        STATS: "/dashboard/generator/readings/summary?",
        CHART: "/dashboard/generator/readings"
    },

       ENERGY_AUDIT: {
        CONSUMER: {
            COSNUMER_DETAILS: "/dashboard/consumer/audit/summary",
            REPORT: "/dashboard/consumer/audit/list"
        },
        GENERATOR: {
            COSNUMER_DETAILS: "/dashboard/admin/generator/audit/summary",
            REPORT: "/dashboard/admin/generator/audit/list"
        }
    },
    
    ONBOARDING: {
        GENERATORS: {
            REPORT: "/users/generator/list",
            CREATE: "users/generator/add",
            UPDATE_STATUS: (id: string) => `/admin/generators/${id}/status`,
            DETAILS: "/users/generator/:consumerId/details",

        },
        CONSUMER: {
            REPORT: "/dashboard/consumer/list",
            CREATE: "/admin/consumer/create",

            UPDATE_STATUS: (id: string) => `/admin/generators/${id}/status`
        },
    },


    GEC_SUMMARY: {
        GEC_SUMMARY: "/dashboard/generator/certificate/summary",
        GEC_LIST: "/users/generator/certificates/list",

    },

    TOKEN_WALLET: {
        TOKEN_WALLET_SUMMARY: "/dashboard/generator/token/summary",
        TOKEN_WALLET_LIST: "/users/generator/tokens/list",

    },
    PERFORMANCE_REPORT: {
        PERFORMANCE_REPORT_SUMMARY: "dashboard/generator/performance/summary",
        PERFORMANCE_REPORT_LIST: "/users/generator/performance/list",

    },
    SELF_SERVICE: {
        QUERY_REQUEST: {
            ALL_REQUESTS: "/ticket/list",
            POST_QUERY_REQUEST: "/ticket/raise",
            QUERY_DETAILS: "/admin/ticket/details/:ticketId",
            COMMENT: "/ticket/comment"
        }
    }
    // Add more endpoints as needed
} as const;

export {
    BASE_URL,
    API_ENDPOINTS
}